/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ReadmitToFacility200ResponseData } from './ReadmitToFacility200ResponseData';
import {
    ReadmitToFacility200ResponseDataFromJSON,
    ReadmitToFacility200ResponseDataFromJSONTyped,
    ReadmitToFacility200ResponseDataToJSON,
} from './ReadmitToFacility200ResponseData';

/**
 * 
 * @export
 * @interface ReadmitToFacility200Response
 */
export interface ReadmitToFacility200Response {
    /**
     * 
     * @type {ReadmitToFacility200ResponseData}
     * @memberof ReadmitToFacility200Response
     */
    data?: ReadmitToFacility200ResponseData;
}

/**
 * Check if a given object implements the ReadmitToFacility200Response interface.
 */
export function instanceOfReadmitToFacility200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ReadmitToFacility200ResponseFromJSON(json: any): ReadmitToFacility200Response {
    return ReadmitToFacility200ResponseFromJSONTyped(json, false);
}

export function ReadmitToFacility200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReadmitToFacility200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ReadmitToFacility200ResponseDataFromJSON(json['data']),
    };
}

export function ReadmitToFacility200ResponseToJSON(value?: ReadmitToFacility200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': ReadmitToFacility200ResponseDataToJSON(value.data),
    };
}

